export default "__VITE_ASSET__d0801265__"